import { FormField } from "./FormField.tsx";
import { Input } from "../atoms/Input.tsx";
import { Switch } from "../atoms/Switch.tsx";

interface Props {
  published: boolean;
  sortOrder: number;
  onPublished: (v: boolean) => void;
  onSortOrder: (v: number) => void;
  error?: string;
}

/** The published + sortOrder controls shared by every content form. */
export function MetaFields({ published, sortOrder, onPublished, onSortOrder, error }: Props) {
  return (
    <div className="field-row">
      <FormField label="Sort order" error={error}>
        <Input
          type="number"
          value={sortOrder}
          onChange={(e) => onSortOrder(Number(e.target.value))}
        />
      </FormField>
      <FormField label="Published">
        <div style={{ paddingTop: 8 }}>
          <Switch checked={published} onChange={onPublished} label={published ? "Published" : "Draft"} />
        </div>
      </FormField>
    </div>
  );
}
